<div class="x_keypad-title">
  <!-- Title will be inserted here  -->
  <ng-content></ng-content>
</div>
<div class="keypad-loader-container" [class.with-loader]="showLoader">
  <div class="keypad-display-container">
    @for (display of displaysSet; track display) {
      <keypad-display
        [displayedValue]="display.value"
        [isInvalid]="isInvalid"
        [errorMessage]="errorMessage"
        [ngClass]="{ 'long-input-value': isLongInputValue }"
        [isActive]="display.keypadType === activeDisplayType"
        [isDefaultMinValue]="display.isDefaultMinValue"
        [measure]="measure"
        [config]="display.config"
        (click)="onChangeDisplayType(display)"
        (pop)="onKeyPadEvent($event)"
      >
      </keypad-display>
    }
    <!-- common error message for the group of the keypad-display inputs -->
    @if (groupedErrorMessage) {
      <div
        class="x_input-error-msg"
        [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_GROUPED_ERROR_MESSAGE"
      >
        {{ groupedErrorMessage }}
      </div>
    }
    <keypad-container
      (push)="onKeyPadEvent($event)"
      [keypadType]="activeDisplayType"
      [buttons]="buttons"
    >
    </keypad-container>
  </div>
  @if (showLoader) {
    <loader
      [isDefaultSize]="true"
      [message]="loaderMessage"
      [noBackground]="true"
      class="center"
    ></loader>
  }
</div>
